module.exports = __webpack_public_path__ + "static/media/client-dark-a.8c9ad9ad.png";